import Head from "next/head"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { useQuery } from "@blitzjs/rpc"
import Layout from "app/core/layouts/Layout"
import Suspense from "app/core/components/Suspense"
import getLanguages from "app/languages/queries/getLanguages"

import Container from "@mui/material/Container"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"

export const LanguagesList = () => {
  const router = useRouter()
  const page = Number(router.query.page) || 0
  const [languages] = useQuery(getLanguages, {
    orderBy: { code: "asc" },
  })

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {languages.map((language) => (
            <TableRow key={language.id}>
              <TableCell>{language.code}</TableCell>
              <TableCell>{language.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const LanguagesPage: BlitzPage = () => {
  return (
    <>
      <Head>
        <title>Languages</title>
      </Head>

      <Container maxWidth={false}>
        <Typography sx={{ my: 4 }} variant="h4" component="h2">
          Languages
        </Typography>
        <Suspense>
          <LanguagesList />
        </Suspense>
      </Container>
    </>
  )
}

LanguagesPage.authenticate = true
LanguagesPage.getLayout = (page) => <Layout>{page}</Layout>

export default LanguagesPage
